import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b0c0ebd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 mx-auto" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-10 pb-lg-15\" data-v-5b0c0ebd><h2 class=\"fw-bold d-flex align-items-center text-dark\" data-v-5b0c0ebd> Choose Country <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" title=\"Billing is issued based on your selected account type\" data-v-5b0c0ebd></i></h2><div class=\"text-gray-400 fw-semobold fs-6\" data-v-5b0c0ebd> If you need more info, please check out <a href=\"https://morrisonrecordsbureau.com/contact-us/\" target=\"_blank\" class=\"link-primary fw-bold\" data-v-5b0c0ebd>Help Page</a>. </div></div>", 1)
const _hoisted_6 = { class: "fv-row mb-8" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-4 d-block" }, "Country ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_autocomplete, {
              class: "inline-input w-100",
              modelValue: _ctx.country,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.country) = $event)),
              "fetch-suggestions": _ctx.searchCountries,
              placeholder: "Search a country"
            }, {
              default: _withCtx(({ item }) => [
                _createElementVNode("span", null, _toDisplayString(item.name), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "fetch-suggestions"])
          ])
        ])
      ])
    ])
  ]))
}